import {
  CadastrosMuiProvider,
  CadastrosMuiLayout,
} from "../Modulos/Cadastros/layout";

const Cadastros = () => (
  <CadastrosMuiProvider>
    <CadastrosMuiLayout />
  </CadastrosMuiProvider>
);

export default Cadastros;
